<app-header [class]="state ? 'fixed-top':'hide-top'"></app-header>
<app-media></app-media>

<router-outlet></router-outlet>
<app-footer></app-footer>
